import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="infinite-scroll"
//
// Handles the "Cargar más" button on the passes index. The button's href
// already carries the current filters (q params) and the next page number, so
// page state lives server-side — this controller just fetches that URL as a
// Turbo Stream and lets Turbo apply the append + button replacement.
export default class extends Controller {
  static targets = ["entries", "button"]

  connect() {
    this.loading = false
  }

  async loadMore(event) {
    event.preventDefault()

    if (this.loading) return
    this.loading = true

    const button = this.buttonTarget
    const originalText = button.innerHTML
    button.innerHTML = "Cargando..."
    button.classList.add("disabled")

    try {
      const response = await fetch(button.href, {
        headers: { "Accept": "text/vnd.turbo-stream.html" }
      })

      if (response.ok) {
        window.Turbo.renderStreamMessage(await response.text())
      } else {
        button.innerHTML = originalText
        button.classList.remove("disabled")
      }
    } catch (error) {
      button.innerHTML = originalText
      button.classList.remove("disabled")
    } finally {
      this.loading = false
    }
  }
}
